!function (n, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports) : "function" == typeof define && define.amd ? define(["exports"], t) : t((n = n || self).TypesafeActions = {});
}(this, function (n) {
  "use strict";

  function t(n, t) {
    return void 0 === t && (t = 1), null == n;
  }

  function r(n) {
    throw void 0 === n && (n = 1), new Error("Argument " + n + " is empty.");
  }

  function e(n) {
    return "function" == typeof n && "getType" in n;
  }

  function i(n) {
    throw void 0 === n && (n = 1), new Error("Argument " + n + ' is invalid, it should be an action-creator instance from "typesafe-actions"');
  }

  function o(n, t) {
    if (null == n) throw new Error("Argument contains array with empty element at index " + t);
    if (null == n.getType) throw new Error("Argument contains array with invalid element at index " + t + ', it should be an action-creator instance from "typesafe-actions"');
  }

  function u(n) {
    return "string" == typeof n || "symbol" == typeof n;
  }

  function c(n) {
    return !u(n);
  }

  function a(n) {
    throw void 0 === n && (n = 1), new Error("Argument " + n + " is invalid, it should be an action type of type: string | symbol");
  }

  function f(n, t) {
    if (null == n) throw new Error("Argument contains array with empty element at index " + t);
    if ("string" != typeof n && "symbol" != typeof n) throw new Error("Argument contains array with invalid element at index " + t + ", it should be of type: string | symbol");
  }

  function s(n, e, o, u) {
    return t(n) && r(1), c(n) && i(1), {
      type: n,
      payload: e,
      meta: o,
      error: u
    };
  }

  function y(n, e) {
    t(n) && r(1), c(n) && a(1);
    var i = null != e ? e(n) : function () {
      return {
        type: n
      };
    };
    return Object.assign(i, {
      getType: function getType() {
        return n;
      },
      toString: function toString() {
        return n;
      }
    });
  }

  function p(n) {
    return t(n) && r(1), c(n) && a(1), Object.assign(function () {
      return y(n, function (n) {
        return function (t, r) {
          return {
            type: n,
            payload: t,
            meta: r
          };
        };
      });
    }, {
      map: function map(t) {
        return y(n, function (n) {
          return function (r, e) {
            return Object.assign(t(r, e), {
              type: n
            });
          };
        });
      }
    });
  }

  function l(n) {
    return t(n) && r(1), e(n) || i(1), n.getType();
  }

  n.action = s, n.createAction = function (n, t) {
    var r = null == t ? function () {
      return s(n);
    } : t(s.bind(null, n));
    return Object.assign(r, {
      getType: function getType() {
        return n;
      },
      toString: function toString() {
        return n;
      }
    });
  }, n.createActionDeprecated = function (n, t) {
    var r;

    if (null != t) {
      if ("function" != typeof t) throw new Error("second argument is not a function");
      r = t;
    } else r = function r() {
      return {
        type: n
      };
    };

    if (null == n) throw new Error("first argument is missing");
    if ("string" != typeof n && "symbol" != typeof n) throw new Error("first argument should be type of: string | symbol");
    return r;
  }, n.createAsyncAction = function (n, t, r, e) {
    return [n, t, r].forEach(f), Object.assign(function () {
      return {
        request: p(n)(),
        success: p(t)(),
        failure: p(r)(),
        cancel: e && p(e)()
      };
    }, {});
  }, n.createCustomAction = y, n.createReducer = function n(t, r) {
    void 0 === r && (r = {});
    var i = Object.assign({}, r);
    return Object.assign(function (n, r) {
      if (void 0 === n && (n = t), i.hasOwnProperty(r.type)) {
        var e = i[r.type];
        if ("function" != typeof e) throw Error('Reducer under "' + r.type + '" key is not a valid reducer');
        return e(n, r);
      }

      return n;
    }, {
      handlers: Object.assign({}, i),
      handleAction: function handleAction(r, o) {
        var c = Array.isArray(r) ? r : [r],
            a = {};
        return c.map(function (n) {
          return e(n) ? l(n) : u(n) ? n : function (n) {
            throw void 0 === n && (n = 1), new Error("Argument " + n + ' is invalid, it should be an action-creator instance from "typesafe-actions" or action type of type: string | symbol');
          }();
        }).forEach(function (n) {
          return a[n] = o;
        }), n(t, Object.assign({}, i, a));
      }
    });
  }, n.createStandardAction = p, n.getType = l, n.isActionOf = function (n, e) {
    t(n) && r(1);
    var i = Array.isArray(n) ? n : [n];
    i.forEach(o);

    var u = function u(n) {
      return i.some(function (t) {
        return n.type === t.getType();
      });
    };

    return void 0 === e ? u : u(e);
  }, n.isOfType = function (n, e) {
    t(n) && r(1);
    var i = Array.isArray(n) ? n : [n];
    i.forEach(f);

    var o = function o(n) {
      return i.includes(n.type);
    };

    return void 0 === e ? o : o(e);
  };
});